module.exports = __webpack_public_path__ + "static/media/5DPO5.7cb356a3.jpg";